<template>
    <div class="atlas-spinner-container">
        <div class="atlas-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>